import { notification } from 'antd'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import useFeatureFlag from '../../hooks/useFeatureFlag'
import { detailsSaveErrorMessage } from '../../components/jobs/jobNumberModel'
import { JOB_DETAILS_CLEANUP_FEATURE } from './jobs'
import { SaveJobNumberingSettingsRequest } from './jobNumbering'
import { getJobNumberingSettings, saveJobNumberingSettings } from './jobNumberingApi'

const jobNumberingSettingsKey = ['job-numbering-settings']

export const useJobNumberingSettingsQuery = () => {
  const isFeatureEnabled = useFeatureFlag(JOB_DETAILS_CLEANUP_FEATURE)
  const query = useQuery(jobNumberingSettingsKey, getJobNumberingSettings, {
    enabled: isFeatureEnabled,
    refetchOnWindowFocus: false,
    staleTime: 30 * 1000,
    onError: () => {
      notification.error({ message: 'There was a problem loading your job numbering settings.' })
    },
  })
  return { ...query, isFeatureEnabled }
}

export const useJobNumberingAvailable = (): boolean => {
  const { data, isFeatureEnabled } = useJobNumberingSettingsQuery()
  return isFeatureEnabled && data?.available === true
}

export const useSaveJobNumberingSettingsMutation = (onFailure: (message: string) => void) => {
  const client = useQueryClient()
  return useMutation((request: SaveJobNumberingSettingsRequest) => saveJobNumberingSettings(request), {
    onSuccess: saved => {
      client.setQueryData(jobNumberingSettingsKey, saved)
    },
    onError: (error: unknown) => {
      onFailure(detailsSaveErrorMessage(error) ?? 'Job numbering settings could not be saved.')
    },
  })
}
